export default __webpack_public_path__ + "static/media/transferencia-bancaria.37d004a9.svg";